import { cx } from '@/utils/cx'
import { Button, DocumentCheckbox } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import PrivacyPolicy from '@assets/privacy_policy.pdf'
import PrivacyPolicyDe from '@assets/privacy_policy_de.pdf'
import tink from '@assets/tink_logo.png'
import { StoreContext } from '@store/Root.store'
import { IkanoInfoGraph } from './icons/IkanoInfoGraph'
import { CheckedEvent } from '@/types/generic'

export const MicropaymentInfoIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { language } = store.TranslationsState
  const {
    klarnaPrivacyPolicyPage: policyPage,
    micropaymentInfoIkanoPage: trans,
    generalConditionsPage: generalConditionsTrans,
  } = store.TranslationsState.translations

  const [consent, setConsent] = useState(false)

  const { isMobile } = store.AppState

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  const handleConsent = ({ checked: value }: CheckedEvent) => {
    setConsent(value)
  }

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40')}>
      <div className="ikano__micropayment-info-graph">
        <IkanoInfoGraph />
      </div>

      {trans.content.split('\n').map((item, i) => (
        <div className="generic__micropayment-info-content" key={i}>
          {item}
        </div>
      ))}

      <div className="ikano__tink-info">
        <div className="ikano__center-liner">
          <img src={tink} alt="tink logo" />
        </div>
        {trans.tink}
      </div>

      <DocumentCheckbox
        inputName="terms-checkbox"
        description={policyPage.consent}
        externalUrl={language === 'de' ? PrivacyPolicyDe : PrivacyPolicy}
        handleDecision={handleConsent}
        value={consent}
        goToDocumentLabel={generalConditionsTrans.goToDocument}
      />

      <div className="layout__content-container-bottom-fixed">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}
        <Button onClick={() => handleProceed()} disabled={!consent}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>

      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </div>
  )
})
